import { postLogin } from 'helpers/api';
import { getUrlParamsByName } from 'helpers/utils';
import { setUserDetails } from 'js/modules/user';

const state = {
    isFetching: false,
    spinner: document.getElementsByClassName('js--spinner')[0],
};

async function attemptLogin(e, url = '') {
    e.preventDefault();

    if (state.isFetching) {
        return;
    }

    const valueOne = document.getElementById('Username').value;
    const valueTwo = document.getElementById('Password').value;

    window.localStorage.setItem(
        'username',
        document.getElementById('rememberMe').checked ? valueOne : '',
    );

    state.isFetching = true;
    state.spinner.classList.remove('ob__spinner--hidden');
    state.spinner.classList.remove('ob__spinner--opacity');
    const res = await postLogin({
        valueOne,
        valueTwo,
    });

    if (res.status && res.status === 200) {
        await setUserDetails(true);
        return (window.location.href = url.length
            ? url
            : document.getElementsByClassName('js--login')[0].getAttribute('data-redirect'));
    }

    state.isFetching = false;
    state.spinner.classList.add('ob__spinner--opacity');
    state.spinner.classList.add('ob__spinner--hidden');
    console.log(res.data.Message);
    const errMsg = res.data.Message || 'Invalid username or password.';

    document.getElementsByClassName('js--login-error')[0].innerHTML = errMsg;
    document.getElementsByClassName('js--login-error')[0].classList.add('login__error--active');
}

function handleAdminRedirect(url) {
    if (url.indexOf('sitefinity') === -1) {
        return;
    }

    document.body.classList.add('admin-login');
    document.getElementsByClassName('js--login-group')[0].innerHTML = 'Admin';
}

function checkRememberMe() {
    const username = window.localStorage.getItem('username');
    if (!username) {
        return;
    }

    document.getElementById('Username').value = username;
    document.getElementById('rememberMe').checked = true;
}

function init() {
    const redirect = getUrlParamsByName('ReturnUrl') || '';

    checkRememberMe();
    handleAdminRedirect(redirect);
    document
        .getElementsByClassName('js--login-form')[0]
        .addEventListener('submit', (e) => attemptLogin(e, redirect));
}

export default init;



// WEBPACK FOOTER //
// ./app/js/modules/login.js